import injectSheet from "react-jss";
import ErgoModal from "./ergo-elements/components/Modal";
import React from "react";

const modalStyles = {
  modal: {
    padding: 0,
    "& .ee_modal__header+.ee_modal__content": {
      padding: 5,
    },
    "& .ee_modal__main": {
      minWidth: "800px",
      marginLeft: ({ margin }) => (margin ? 100 : 0),
      marginBottom: ({ margin }) => (margin ? 200 : 0),
    },
  },
};

export const Modal = injectSheet(modalStyles)(({
  classes,
  className,
  margin,
  ...props
}) => {
  return <ErgoModal className={`${classes.modal} ${className}`} {...props} />;
});
